import { PolicyholderType } from "@covertree/new-business-graphql";

export const primaryInsuredTypeOption: {
  value: PolicyholderType;
  label: string;
}[] = [
  {
    label: "Person",
    value: PolicyholderType.Person,
  },
  { label: "Organization", value: PolicyholderType.Organization },
];
